import type { NetPriceData } from "~/domains/pricing/types/PriceData";

export function getAddToCartResultBasePrice(
  specialPrice: boolean | undefined,
  price: NetPriceData | undefined,
): number | null {
  if (!specialPrice || !price || price.baseValue === price.value) {
    return null;
  }

  return price.baseValue;
}
